import {Component, OnDestroy, OnInit} from '@angular/core';
import {ServiceChangesModel} from '../../../models/ServiceChangesModel';
import {Subscription} from 'rxjs';
import {MatDialog, MatTableDataSource} from '@angular/material';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {RegionModel} from '../../../models/RegionModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ServiceChangesService} from '../service/service-changes.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {DialogSubmitServiceChangesComponent} from '../dialog-submit-service-changes/dialog-submit-service-changes.component';
import {ProviderModel} from '../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';

@Component({
  selector: 'app-edit-service-changes-massive',
  templateUrl: './edit-service-changes-massive.component.html',
  styleUrls: ['./edit-service-changes-massive.component.scss']
})
export class EditServiceChangesMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  serviceChangesEdit: ServiceChangesModel;
  getPageSubscribe: Subscription;
  serviceChanges: ServiceChangesModel;
  allMonth: any;
  listData: MatTableDataSource<any>;
  contractualDataJson: any;

  numAnnoMeseSelect: number;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  resourceUnitSelect: ResourcesUnitModel;
  shareNameSelect: string;
  deltaSelect: number;
  contractTypeSelect: ContractTypeModel;
  providerSelect: ProviderModel;

  saveServiceChanges: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;  submitted = false;
  numAnnoMeseFrom: any;


  constructor(private route: ActivatedRoute, private router: Router,
              private serviceChangesService: ServiceChangesService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private dialog: MatDialog) {
    super();

    this.showActions = false;
    this.serviceChanges = new ServiceChangesModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();
    this.shareNameSelect = '';
    this.deltaSelect =  0;
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.contractualDataJson = params['row'];
      });
    this.serviceChangesEdit = JSON.parse(this.contractualDataJson) as ServiceChangesModel;

    this.numAnnoMeseSelect = this.serviceChangesEdit.numAnnoMese;
    this.regionSelect = this.serviceChangesEdit.region;
    this.localCustomerSelect = this.serviceChangesEdit.localCustomer;
    this.resourceUnitSelect = this.serviceChangesEdit.resourceUnit;
    this.shareNameSelect = this.serviceChangesEdit.shareName;
    this.contractTypeSelect = this.serviceChangesEdit.contractType;
    this.providerSelect = this.serviceChangesEdit.provider;
    this.deltaSelect =  this.serviceChangesEdit.delta;

    this.registerForm = this.formBuilder.group({
      localCustomer: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      resourceUnitName: [{value: '', disabled: false}, Validators.required],
      resourceUnitCod: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      shareName: [{value: '', disabled: false}],
      delta: [{value: '', disabled: false}, Validators.required],
      annoMeseFrom: [{value: '', disabled: false}, Validators.required],
      annoMeseTo: [{value: '', disabled: false}, Validators.required],
    });

    this.registerForm.patchValue({
      annoMeseFrom: this.numAnnoMeseSelect ? this.numAnnoMeseSelect : ''
    });
    this.registerForm.patchValue({
      localCustomer: this.localCustomerSelect ? this.localCustomerSelect.cod : ''
    });

    this.registerForm.patchValue({
      region: this.regionSelect ? this.regionSelect.cod : ''
    });

    this.registerForm.patchValue({
      resourceUnitName: this.resourceUnitSelect ? this.resourceUnitSelect.name : ''
    });

    this.registerForm.patchValue({
      resourceUnitCod: this.resourceUnitSelect ? this.resourceUnitSelect.cod : ''
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect ? this.contractTypeSelect.cod : ''
    });

    this.registerForm.patchValue({
      provider: this.providerSelect ? this.providerSelect.cod : ''
    });

    this.registerForm.patchValue({
      shareName: this.shareNameSelect ? this.shareNameSelect : ''
    });

    this.registerForm.patchValue({
      delta: this.deltaSelect ? this.deltaSelect : ''
    });

    this.serviceChanges.id = this.serviceChangesEdit.id;
    this.serviceChanges.localCustomer = this.localCustomerSelect;
    this.serviceChanges.region = this.regionSelect;
    this.serviceChanges.resourceUnit = this.resourceUnitSelect;
    this.serviceChanges.provider = this.providerSelect;
    this.serviceChanges.shareName = this.shareNameSelect;
    this.serviceChanges.delta = this.deltaSelect;

    this.getAllMonth();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SERVICE_CHANGES]);
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.serviceChanges.shareName = this.registerForm.value.shareName;
      this.serviceChanges.delta = this.registerForm.value.delta;
      this.serviceChanges.numAnnoMese = null;
      this.serviceChanges.numAnnoMeseFrom = this.registerForm.value.annoMeseFrom;
      this.serviceChanges.numAnnoMeseTo = this.registerForm.value.annoMeseTo;

      event.preventDefault();
      this.loaderService.display(true);
      this.saveServiceChanges = this.serviceChangesService.updateMassive(this.serviceChangesService.baseUrl, this.serviceChanges)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Service Change was created with success', 'Success');
              this.loaderService.display(false);
              this.openDialog(result);
              this.router.navigate([this.LINKS.SERVICE_CHANGES]);
            }
          },
          error => {
            toastr.error('Service Change was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth()
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  ngOnDestroy(): void {
    if (this.saveServiceChanges) {
      this.saveServiceChanges.unsubscribe();
    }
  }

  handleNumAnnoMeseFrom(value) {
    this.serviceChanges.numAnnoMeseFrom = value;
    this.registerForm.patchValue({
      annoMeseFrom: value
    });
  }
  handleNumAnnoMeseTo(value) {
    this.serviceChanges.numAnnoMeseTo = value;
    this.registerForm.patchValue({
      annoMeseTo: value
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  openDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitServiceChangesComponent, {
      data: {result}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }
}
